import React, { useState, useEffect } from 'react';

import FumigationCompany from "../FumigationCompany/FumigationCompany";
import CustomerInformation from '../CustomerInformation/CustomerInformation';
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions';
import { applicationData } from 'contexts/applicationDataFieldTypes';
import { ValidationResult, EMPTY_VALIDATION_RESULT } from '../validation/fumigationValidation';

interface ApplicationCompositeProps {
    applicationData: applicationData;
    setApplicationData: React.Dispatch<React.SetStateAction<applicationData>>;
    checkedTermsAndConditions: boolean;
    setCheckedTermsAndConditions: React.Dispatch<React.SetStateAction<boolean>>;
    control: any;
    setValue: any;
    validation?: ValidationResult;
    showValidation?: boolean;
    fumigationCompanyRef?: React.RefObject<HTMLDivElement>;
    customerInformationRef?: React.RefObject<HTMLDivElement>;
    termsAndConditionsRef?: React.RefObject<HTMLDivElement>;
}

const ApplicationComposite: React.FC<ApplicationCompositeProps> = ({ 
    applicationData, 
    setApplicationData, 
    checkedTermsAndConditions, 
    setCheckedTermsAndConditions, 
    control, 
    setValue, 
    validation = EMPTY_VALIDATION_RESULT, 
    showValidation = false,
    fumigationCompanyRef,
    customerInformationRef,
    termsAndConditionsRef
}) => {



    const [fumigationCompanyToggle, setFumigationCompanyToggle] = useState(true);
    const [customerInformationToggle, setCustomerInformationToggle] = useState(true);
    const [termsAndConditionsToggle, setTermsAndConditionsToggle] = useState(true);


    return (
        <>
            <FumigationCompany
                applicationData={applicationData}
                setApplicationData={setApplicationData}
                control={control}
                toggle={fumigationCompanyToggle}
                setToggle={setFumigationCompanyToggle}
                fieldErrors={showValidation ? validation.headerFieldErrors : {}}
                sectionRef={fumigationCompanyRef}
            />
            <CustomerInformation
                applicationData={applicationData}
                setApplicationData={setApplicationData}
                toggle={customerInformationToggle}
                setToggle={setCustomerInformationToggle}
                control={control}
                recordFieldErrors={showValidation ? validation.recordFieldErrors : {}}
                lineErrors={showValidation ? validation.lineErrors : []}
                sectionRef={customerInformationRef}
            />
            <TermsAndConditions
                applicationData={applicationData}
                setApplicationData={setApplicationData}
                toggle={termsAndConditionsToggle}
                setToggle={setTermsAndConditionsToggle}
                checkedTermsAndConditions={checkedTermsAndConditions}
                setCheckedTermsAndConditions={setCheckedTermsAndConditions}
                control={control}
                termsError={showValidation ? validation.termsError : ''}
                sectionRef={termsAndConditionsRef}
            />
        </>
    );

}

export default ApplicationComposite;